import { CatalogProductMatch } from './result-model'

export type ProductGroupName = 'supplier' | 'catalog'
export type ProductRow = { article_score?: number; id: string; product: CatalogProductMatch; supplier?: string; supplier_name?: string; supplier_article?: string }
export type ProductGroup = { data: ProductRow[]; next_cursor: string | null }
export type ProductSearchResult = Record<ProductGroupName, ProductGroup>

const productKey = (row: ProductRow) => row.product.product_id ? JSON.stringify([
  row.product.product_id, row.product.unit_id || '', String(row.product.unit || '').trim().toLocaleLowerCase('ru-RU'),
]) : null

export const visibleProductGroups = (result: ProductSearchResult): ProductSearchResult => {
  const supplierKeys = new Set(result.supplier.data.map(productKey).filter(Boolean))
  const seen = new Set<string>()
  const catalog = result.catalog.data.filter(row => {
    const key = productKey(row)
    if (!key) return true
    if (supplierKeys.has(key) || seen.has(key)) return false
    seen.add(key)
    return true
  })
  const supplierIds = new Set<string>()
  const supplier = result.supplier.data.filter(row => {
    const key = productKey(row)
    if (!key) return true
    const identity = JSON.stringify([key, row.supplier, row.supplier_name, row.supplier_article])
    if (supplierIds.has(identity)) return false
    supplierIds.add(identity)
    return true
  })
  return { supplier: { ...result.supplier, data: supplier }, catalog: { ...result.catalog, data: catalog } }
}
